// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2-jE9","main-container":"styles_main-container__38haS","center-box":"styles_center-box__24aD7","line":"styles_line__OWKen"};